import 'babel-polyfill';
import 'url-search-params-polyfill';
import './index.css';
import { addTranslation } from 'react-localize-redux';
import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import configureStore from './store/store';
//import registerServiceWorker from './registerServiceWorker';

import translations from './global.locale.json';

if (window.Bugsnag) {
    window.Bugsnag.releaseStage = process.env.REACT_APP_BUILD === 'prod' ? 'production' : 'development';
    window.Bugsnag.enableNotifyUnhandledRejections();
}

const store = configureStore({
    locale: {
        languages: [
            {
                code: 'en',
                active: true
            }
        ],
        options: {}
    }
});
store.dispatch(addTranslation(translations));
ReactDOM.render(<App store={store} />, document.getElementById('root'));
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js